import Vue from 'vue';

import './plugins';
import i18n from './plugins/vue-i18n';

import App from './App.vue';
import router from './router';
import store from './store';

import vuetify from './plugins/vuetify';

import './assets/stylesheets/main.scss';

Vue.config.productionTip = process.env.NODE_ENV === 'production';

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
